export { SearchBoxDesktop } from "./Desktop";
export { SearchBoxMobile } from "./Mobile";